(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    (function() {
      function truncateHTML(html, maxChars) {
        // Crear un elemento temporal para trabajar con el HTML
        const temp = document.createElement('div');
        temp.innerHTML = html;
        
        // Obtener texto plano para contar caracteres
        const plainText = temp.textContent || temp.innerText || '';
        
        if (plainText.length <= maxChars) {
          return { html: html, truncated: false };
        }
        
        // Función recursiva para truncar manteniendo las etiquetas
        let charCount = 0;
        let truncated = false;
        
        function truncateNode(node, max) {
          if (truncated) return;
          
          if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent;
            if (charCount + text.length > max) {
              // Truncar este nodo de texto
              const remaining = max - charCount;
              node.textContent = text.substring(0, remaining) + '...';
              truncated = true;
              charCount = max;
            } else {
              charCount += text.length;
            }
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            // Procesar hijos
            const children = Array.from(node.childNodes);
            for (const child of children) {
              if (truncated) {
                // Eliminar nodos restantes
                node.removeChild(child);
                // Eliminar hermanos siguientes
                let nextSibling = child.nextSibling;
                while (nextSibling) {
                  const toRemove = nextSibling;
                  nextSibling = nextSibling.nextSibling;
                  node.removeChild(toRemove);
                }
                break;
              }
              truncateNode(child, max);
            }
          }
        }
        
        const clone = temp.cloneNode(true);
        truncateNode(clone, maxChars);
        
        return { html: clone.innerHTML, truncated: true };
      }

      function initReadMore(container) {
        const content = container.querySelector('[data-text-content]');
        const button = container.querySelector('[data-read-more-button]');
        const readMoreText = button?.querySelector('.text-block__read-more-text');
        const readLessText = button?.querySelector('.text-block__read-less-text');

        if (!content || !button) return;

        // Get full text and max characters from the wrapper container
        const fullText = container.getAttribute('data-full-text');
        const maxChars = parseInt(container.getAttribute('data-max-chars')) || 200;

        if (!fullText) {
          button.style.display = 'none';
          return;
        }

        // Check if truncation is needed
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = fullText;
        const plainText = tempDiv.textContent || tempDiv.innerText || '';
        
        if (plainText.length <= maxChars) {
          // No truncation needed, hide button
          button.style.display = 'none';
          content.classList.remove('text-block__content--collapsed');
          return;
        }

        // Truncate the content
        const { html: truncatedHTML } = truncateHTML(fullText, maxChars);
        content.innerHTML = truncatedHTML;

        // Content needs truncation, setup toggle
        let isExpanded = false;

        button.addEventListener('click', function(e) {
          e.preventDefault(); // Prevenir comportamiento por defecto del enlace
          isExpanded = !isExpanded;

          if (isExpanded) {
            // Expand - show full text
            content.innerHTML = fullText;
            content.classList.remove('text-block__content--collapsed');
            content.classList.add('text-block__content--expanded');
            if (readMoreText) readMoreText.style.display = 'none';
            if (readLessText) readLessText.style.display = 'inline';
          } else {
            // Collapse - show truncated text
            const { html: truncatedHTML } = truncateHTML(fullText, maxChars);
            content.innerHTML = truncatedHTML;
            content.classList.remove('text-block__content--expanded');
            content.classList.add('text-block__content--collapsed');
            if (readMoreText) readMoreText.style.display = 'inline';
            if (readLessText) readLessText.style.display = 'none';
          }
        });
      }

      function initAllReadMore() {
        const containers = document.querySelectorAll('[data-text-block-wrapper]');
        containers.forEach(container => {
          // Evitar múltiples inicializaciones
          if (!container.dataset.readMoreInitialized) {
            container.dataset.readMoreInitialized = 'true';
            initReadMore(container);
          }
        });
      }

      // Initialize on DOM ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAllReadMore);
      } else {
        initAllReadMore();
      }

      // Re-initialize when Shopify loads a section or block
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', function() {
          // Reset initialization flags for newly loaded sections
          const containers = document.querySelectorAll('[data-text-block-wrapper]');
          containers.forEach(container => {
            delete container.dataset.readMoreInitialized;
          });
          initAllReadMore();
        });
        document.addEventListener('shopify:section:select', initAllReadMore);
        document.addEventListener('shopify:block:select', initAllReadMore);
      }
    })();
  } catch(e) { console.error(e); }
})();

})();
